function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod, chat_group) {
  var html = "\n   <div class=\"saito-modal saito-modal-menu\" id=\"saito-chat-menu\">\n    <div class=\"saito-modal-title\">".concat(chat_group.name, "</div>\n     <div class=\"saito-modal-content saito-menu-select-heavy\">");
  if (chat_group.id !== mod.communityGroup.id) {
    html += "<div id=\"rename\" class=\"saito-modal-menu-option\"><i class=\"fa-regular fa-id-card\"></i><div>Rename</div></div>";
  }
  if (chat_group !== null && chat_group !== void 0 && chat_group.muted) {
    html += "<div id=\"unmute\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-volume-high\"></i><div>Unmute</div></div>";
  } else {
    html += "<div id=\"mute\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-volume-xmark\"></i><div>Mute</div></div>";
  }
  html += "<div id=\"delete\" class=\"saito-modal-menu-option\"><i class=\"fas fa-trash-alt\"></i><div>Remove</div></div>\n      ";
  if (chat_group.id !== mod.communityGroup.id) {
    if (chat_group !== null && chat_group !== void 0 && chat_group.member_ids || chat_group.members.length > 2) {
      html += "<div id=\"leave\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-door-open\"></i><div>Leave Group</div></div>";
    } else {
      var other_party = '';
      var _iterator = _createForOfIteratorHelper(chat_group.members),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mem = _step.value;
          if (mem !== mod.publicKey) {
            other_party = mem;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (mod.black_list.includes(other_party)) {
        html += "<div id=\"unblock\" class=\"saito-modal-menu-option\" data-id=\"".concat(other_party, "\"><i class=\"fa-regular fa-circle-check\"></i><div>Unblock</div></div>");
      } else {
        html += "<div id=\"block\" class=\"saito-modal-menu-option\"><i class=\"fas fa-ban\"></i><div>Block</div></div>";
      }
    }
  }
  if (chat_group !== null && chat_group !== void 0 && chat_group.member_ids) {
    html += "<div id=\"invite\" class=\"saito-modal-menu-option\"><i class=\"fas fa-link\"></i><div>Invite member</div></div>";
    if (chat_group.member_ids[mod.publicKey] == 'admin') {
      html += "<div id=\"admin\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-key\"></i><div>Promote Admin</div></div>";
      html += "<div id=\"remove\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-user-minus\"></i><div>Remove member</div></div>";
    }
    html += "<div id=\"view\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-users\"></i><div>View members</div></div>";
  } else {
    //Or we can query the community group for recently active keys
    if (chat_group.id == mod.communityGroup.id || chat_group.members.length > 2) {
      html += "<div id=\"view\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-users\"></i><div>View members</div></div>";
    }
  }
  html += "<div id=\"debug\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-question\"></i><div>Debug</div></div>";
  html += '</div></div>';
  return html;
};